import { createContext, useContext, useState } from "react";

import { ProgressSpinner } from "primereact/progressspinner";

import { LoaderSpinnerContextType } from "interfaces";

const LoaderSpinnerContext = createContext<LoaderSpinnerContextType>(
  {} as LoaderSpinnerContextType
);
export const useLoaderSpinner = () => {
  const context = useContext(LoaderSpinnerContext);
  return context;
};

export const LoaderSpinnerProvider: React.FC<any> = ({ children }) => {
  const [show, toggleShow] = useState(false);
  const toggleLoaderSpinner = (showState: boolean = true) => {
    toggleShow(() => showState);
  };

  return (
    <LoaderSpinnerContext.Provider value={{ toggleLoaderSpinner }}>
      {show && (
        <div className="loading-spinner">
          <ProgressSpinner strokeWidth="8" animationDuration="1s" />
        </div>
      )}
      {children}
    </LoaderSpinnerContext.Provider>
  );
};
